import React from 'react';
import { BaseInputProps, Dropdown } from 'ui-builder';
import { getSetupAreaVersionStatusLabel, SetupAreaVersionStatus } from 'nekst-api';

export function SetupAreaVersionStatusDropdown(props: BaseInputProps) {
  return (
    <Dropdown
      options={Object.values(SetupAreaVersionStatus).map((status) => ({
        value: status,
        label: getSetupAreaVersionStatusLabel(status),
      }))}
      {...props}
    />
  );
}
